<template>
    <el-dialog :title="title" width="60%" :close-on-click-modal="false" :visible.sync="visible">
        <el-form size="small" :model="hospitalForm" ref="hospitalForm" label-width="100px" @keyup.enter.native="doSubmit()" v-loading="loading" :disabled="method==='view'" @submit.native.prevent>
            <el-form-item label="城市：" :rules="[{ required: true, message: '请选择城市', trigger: 'blur' }]">
                <el-cascader
                        v-model="hospitalForm.cityId"
                        :options="cityOpt" :props="{ value: 'id', label: 'name' }" style="width: 100%"></el-cascader>
            </el-form-item>
            <el-form-item label="医院名称：" prop="hospitalName"
                          :rules="[{ required: true, message: '请输入医院名称', trigger: 'blur' }]">
                <el-input v-model.trim="hospitalForm.hospitalName" placeholder="请输入医院名称（必填项）" maxlength="50"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                loading: false,
                title: '',
                method: '',
                // 个人信息
                pId: '1277876432646750210',
                hospitalForm: {
                    id: '',
                    cityId: ['1277876432646750210', '738049426362204160'],
                    hospitalName: '',
                },
                cityOpt: [],
            }
        },
        methods: {
            // 初始化数据
            init(method, row) {
                console.log(row);
                this.getCity()
                this.method = method
                if (method === 'add') {
                    this.title = `新建`
                } else if (method === 'edit') {
                    this.title = '修改'
                } else if (method === 'view') {
                    this.title = '查看'
                }
                this.visible = true
                this.$nextTick(() => {
                    if(method != 'add') {
                        this.recover(this.hospitalForm, row);
                        this.$set(this.hospitalForm, 'cityId', [this.pId, row.cityId])
                    } else {
                        this.$refs.hospitalForm.resetFields();
                    }
                })
            },
            // 获取城市
            getCity() {
                this.$axios(this.api.order.getSysArea).then(res => {
                    if (res.status) {
                        this.cityOpt = res.data
                        this.cityOpt[0].children.map(item => {
                            if(!item.children.length) {
                                delete item.children;
                            }
                        })
                    }
                })
            },
            // 表单提交
            doSubmit() {
                this.$refs['hospitalForm'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        if(this.method === 'add') {  // 新增
                            this.$axios(this.api.order.hospitalSave, {
                                cityId: this.hospitalForm.cityId[1],
                                hospitalName: this.hospitalForm.hospitalName
                            }, 'post').then(data => {
                                this.loading = false
                                if (data && data.status) {
                                    this.$message.success(data.msg)
                                    this.visible = false
                                    this.$emit('refreshDataList')
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                        } else if(this.method === 'edit') {  // 修改
                            this.$axios(this.api.order.hospitalUpdate, {
                                id: this.hospitalForm.id,
                                cityId: this.hospitalForm.cityId[1],
                                hospitalName: this.hospitalForm.hospitalName
                            }, 'put').then(data => {
                                this.loading = false
                                if (data && data.status) {
                                    this.visible = false
                                    this.$message.success(data.msg)
                                    this.$emit('refreshDataList')
                                }else{
                                    this.$message.error(data.msg)
                                }
                            })
                        }
                    }
                })
            },
        }
    }
</script>
